export const DEFAULT_VIDEO_CONSTRAINTS: MediaStreamConstraints['video'] = {
  width: 1280,
  height: 720,
  frameRate: 24,
};

export const ApiUrl: String = process.env.REACT_APP_API_URL || 'http://localhost:3000/';

// export const ApiUrl: String = process.env.REACT_APP_API_URL || 'http://192.168.0.39:3000';
